import { createContext } from 'react';

/** Key of the save queue the surrounding form's edits go to; undefined outside an autosaved form. */
export const SaveKeyContext = createContext<string | undefined>(undefined);
